import { createPortal } from 'react-dom';
import { useShareToolContext } from '../../context/ShareToolContext';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const ShareToolTabFooter = ({
  children
}) => {
  const {
    footerRef
  } = useShareToolContext();
  return footerRef.current ? /*#__PURE__*/createPortal( /*#__PURE__*/_jsx(View, {
    borderColor: "border-core-default",
    borderBlockStartWidth: "100",
    borderBlockStartStyle: "solid",
    children: /*#__PURE__*/_jsx(DialogFooter, {
      children: children
    })
  }), footerRef.current) : null;
};